import { View } from "@react-pdf/renderer";
import {


} from "components/Resume/ResumePDF/common";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeSkills } from "lib/redux/types";
import { ResumePDFDescription, TemplateThirteenRightColumnSection } from "./common";

export const Skills = ({
  heading,
  skills,
  themeColor,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
}) => {
  const { descriptions } = skills;
  return (
    <TemplateThirteenRightColumnSection themeColor={themeColor} heading={heading}>
      <View  style={{ ...styles.flexCol }} wrap={false}>
        <ResumePDFDescription  items={descriptions} themeColor="white" />
      </View>
    </TemplateThirteenRightColumnSection>
  );
};
